import React from "react";
import { Box, Typography, Stack, Divider } from "@mui/material";
import { SimpleMetricCardProps } from "../../type";
import { BaseCard } from "./BaseCard";
import { operationsDashboardStyles } from "../../styles";

export const SimpleMetricCard: React.FC<SimpleMetricCardProps> = ({ data }) => {
  return (
    <BaseCard data={data}>
      {data.unit?.includes("%") ? (
        <Typography
          sx={operationsDashboardStyles.valueText}
        >{`${data.value}${data.unit}`}</Typography>
      ) : (
        <Box sx={operationsDashboardStyles.flexCenter}>
          <Typography sx={operationsDashboardStyles.unitText}>
            {data.unit ?? ""}
          </Typography>
          <Typography sx={operationsDashboardStyles.valueText}>
            {data.value}
          </Typography>
          <Typography sx={operationsDashboardStyles.subValueText}>
            {data.subValue}
          </Typography>
        </Box>
      )}

      {(data.forecast ?? data.comparison) && (
        <Divider sx={operationsDashboardStyles.divider} />
      )}

      {(data.forecast ?? data.comparison) && (
        <Box sx={operationsDashboardStyles.bottomSection}>
          <Stack direction="row" sx={operationsDashboardStyles.bottomStack}>
            {data.forecast && (
              <Box>
                <Typography sx={operationsDashboardStyles.comparisonValue}>
                  {data.forecast.value}
                </Typography>
                <Typography sx={operationsDashboardStyles.comparisonLabel}>
                  {data.forecast.label}
                </Typography>
              </Box>
            )}

            {data.comparison && (
              <Box sx={operationsDashboardStyles.comparisonContainer}>
                <Typography sx={operationsDashboardStyles.comparisonValue}>
                  {data.comparison.value}
                </Typography>
                <Typography sx={operationsDashboardStyles.comparisonLabel}>
                  {data.comparison.label}
                </Typography>
              </Box>
            )}
          </Stack>
        </Box>
      )}
    </BaseCard>
  );
};
